module.exports = __webpack_public_path__ + "img/cancel-alert.4c826236.svg";